import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';

type Props = {
    orderNumber: string;
    handleClose: () => void;
    handleCancel: (reason: string) => void;
    show?: boolean;
    pageProps:any,
};

const OrderCancelModal = ({
    orderNumber,
    handleClose,
    handleCancel,
    show = true,
    pageProps
}: Props) => {
    const [reason, setReason] = useState('');

    const onConfirm = () => {
        handleCancel(reason);
    };
    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            size='lg'
            contentClassName="cancel-order-modal"
        >
            <Modal.Header closeButton></Modal.Header>
            <br />
            <div className="cancel-modal-content">
                <h2 className="cancel-title">
                    Are you sure to cancel <br />
                    order: <span className="order-number">#{orderNumber}</span>?
                </h2>
                <textarea
                    className="cancel-textarea"
                    placeholder="Why do you want to cancel this order?"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                ></textarea>
                <div className="cancel-actions">
                    <button className="btn-yes" onClick={onConfirm} disabled={pageProps.changeOrderStatusRequest.is_request_processing}>
                        YES
                    </button>
                    <button className="btn-no" onClick={handleClose} disabled={pageProps.changeOrderStatusRequest.is_request_processing}>
                        NO
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default OrderCancelModal